import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83ecb67e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode("中文")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"100px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('profile')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-text-center",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      ($setup.loading)
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 0,
                            size: "12",
                            class: "ion-text-center ion-margin-top"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_spinner)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!$setup.loading)
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 1,
                            "size-xs": "12",
                            "size-md": "4"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                class: "user-image",
                                src: $setup.user.profilePic
                              }, null, 8, _hoisted_1),
                              _createVNode(_component_ion_button, {
                                class: "ion-margin-top",
                                color: "light",
                                size: "small",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateProfilePic()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.camera
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString($setup.t('UserProfilePage.changeProfilePhoto')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          (!$setup.loading)
                            ? (_openBlock(), _createBlock(_component_ion_card_header, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.user.firstName) + " " + _toDisplayString($setup.user.lastName), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_card_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.user.email), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_card_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.user.phone), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                class: "ion-margin-bottom",
                                expand: "block",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openEditUserProfileModal()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.createOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString($setup.t('UserProfilePage.editPersonalInfo')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.presentChangePasswordPrompt()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.keyOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString($setup.t('UserProfilePage.changePassword')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_list, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    lines: "none",
                                    "router-link": "/notifications",
                                    button: "",
                                    detail: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.notifications
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.t('notifications')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, {
                                    lines: "none",
                                    "router-link": "/orders",
                                    button: "",
                                    detail: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.receipt
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.t('UserProfilePage.myOrders')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, {
                                    lines: "none",
                                    "router-link": "/my-posts",
                                    button: "",
                                    detail: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.newspaper
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.t('UserProfilePage.myPosts')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, {
                                    lines: "full",
                                    "router-link": "/liked-products",
                                    button: "",
                                    detail: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.heart
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.t('UserProfilePage.likedItems')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.globe
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.t('UserProfilePage.language')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_select, {
                                        interface: "popover",
                                        modelValue: $setup.locale,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.locale) = $event))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_select_option, { value: "zh" }, {
                                            default: _withCtx(() => [
                                              _hoisted_2
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_select_option, { value: "en" }, {
                                            default: _withCtx(() => [
                                              _hoisted_3
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.moon
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.t('UserProfilePage.darkTheme')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_toggle, {
                                        slot: "end",
                                        onIonChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleDarkTheme($event.detail.checked))),
                                        checked: $setup.user.darkTheme == 'Y'
                                      }, null, 8, ["checked"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                size: "small",
                                "router-link": "/terms-and-conditions"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('UserProfilePage.termsAndConditions')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                size: "small",
                                "router-link": {
                    name: 'FeedbackPage',
                    state: { passedProduct: null }
                  }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('UserProfilePage.feedback')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                color: "medium",
                size: "small",
                class: "logout-btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.doLogout()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "end",
                    icon: $setup.logOutOutline
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString($setup.t('UserProfilePage.logout')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-justify-content-center ion-margin-top" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_note, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Ver. " + _toDisplayString($setup.versionCode), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("p", null, [
                _createVNode(_component_ion_button, {
                  fill: "clear",
                  color: "danger",
                  size: "small",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.deleteAccount()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('deleteAccount')), 1)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}